import clsx from 'clsx';
import { format } from 'date-fns';
import { ReactElement, RefObject, useRef } from 'react';
import { Button as DayButton, DayProps, useDayRender } from 'react-day-picker';
import { DayRendererModifiers } from './models';

const formats = {
  iso: 'yyyy-MM-dd',
};

export const Day = (props: DayProps): ReactElement => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { isHidden, isButton, divProps, activeModifiers, buttonProps } = useDayRender(
    props.date,
    props.displayMonth,
    buttonRef as RefObject<HTMLButtonElement>,
  );
  const dateTime = format(props.date, formats.iso);

  if (isHidden) {
    return <></>;
  }
  if (!isButton) {
    return <div {...divProps} />;
  }

  return (
    <time
      dateTime={dateTime}
      className={clsx({
        'range-start': activeModifiers[DayRendererModifiers.RangeStart],
        'range-end': activeModifiers[DayRendererModifiers.RangeEnd],
        'in-the-middle': activeModifiers[DayRendererModifiers.InTheMiddle],
      })}
    >
      <DayButton {...buttonProps} ref={buttonRef} />
    </time>
  );
};
